import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, Validators } from '@angular/forms';

@Directive({
  selector: '[wooMinValidator]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: WooMinValidator,
      multi: true,
    },
  ],
})
export class WooMinValidator implements Validator {
  @Input('wooMinValidator') min: number;

  validate(c: AbstractControl): ValidationErrors {
    return Validators.min(this.min)(c);
  }
}
